import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {DocumentModel} from "@app/model/document.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DomSanitizer} from "@angular/platform-browser";
import {HttpClient} from "@angular/common/http";
import {AlertsService} from "@app/services/misc-services/alerts.service";
import {LoginService} from "@app/login/login.service";

@Component({
    selector: 'flex-document-dialog',
    templateUrl: './document-dialog.component.html',
    styleUrls: ['./document-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentDialogComponent implements OnInit {
    user = this.activeUser.getActiveUserSubject()
    file;
    constructor(private http: HttpClient, public alert: AlertsService, private sanitizer: DomSanitizer, private activeUser: LoginService,
                public dialogRef: MatDialogRef<DocumentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DocumentModel) {
    }

    ngOnInit(): void {
        this.file = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.filedata);
    }

    checkType() {
        return this.data.filename?.includes('.pdf' || '.png' || '.jpg');
    }
    previewAndSetDownload() {
        try {
            this.file = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.filedata);
            return this.file;
        } catch (e) {
            this.alert.getError('Unknown error, please try again.', 'X')
        }
    }
}
